import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import './MCM.css';
import './LegalPages.css';

export function MentionsLegales() {
  return (
    <div className="legal-page" data-testid="mentions-legales-page">
      <div className="mcm-container legal-container">
        <Link to="/" className="legal-back" data-testid="back-home-link">
          <ArrowLeft size={18} /> Retour à l'accueil
        </Link>
        <h1 className="legal-title">Mentions légales</h1>
        <p className="legal-updated">Dernière mise à jour : 26 avril 2026</p>

        <h2>1. Éditeur du site</h2>
        <p>
          Le présent site <strong>mcm-consulting.fr</strong> (ou son URL d'hébergement courante)
          est édité par&nbsp;:
        </p>
        <ul>
          <li><strong>Raison sociale</strong> : MCM – Mentis Consilium</li>
          <li><strong>Forme juridique</strong> : SASU au capital variable</li>
          <li><strong>SIRET</strong> : 102 709 086 00015</li>
          <li><strong>Représentant légal</strong> : Mohammed Toummini, Président</li>
          <li><strong>Email</strong> : <a href="mailto:mohammed.toummini@mentisconsilium.com">mohammed.toummini@mentisconsilium.com</a></li>
          <li><strong>Téléphone</strong> : <a href="tel:+33783282634">07 83 28 26 34</a></li>
        </ul>

        <h2>2. Directeur de la publication</h2>
        <p>Mohammed Toummini, Président de MCM – Mentis Consilium.</p>

        <h2>3. Hébergement</h2>
        <p>
          Le site est hébergé par <strong>Surge.sh</strong> (Chloi Inc., 1207 Delaware Avenue #1148,
          Wilmington, DE 19806, USA – <a href="https://surge.sh" target="_blank" rel="noopener noreferrer">surge.sh</a>),
          ou tout autre hébergeur indiqué sur la version courante du site (Netlify, Vercel, Cloudflare Pages…).
        </p>

        <h2>4. Propriété intellectuelle</h2>
        <p>
          L'ensemble des contenus présents sur le site (textes, images, logo, graphismes, icônes, mise en page)
          est la propriété exclusive de MCM – Mentis Consilium ou de ses partenaires, et est protégé
          par le droit d'auteur (articles L.111-1 et suivants du Code de la propriété intellectuelle).
          Toute reproduction, représentation, modification ou diffusion, totale ou partielle, sans autorisation
          écrite préalable est interdite et constitue une contrefaçon.
        </p>

        <h2>5. Liens hypertextes</h2>
        <p>
          Le site peut contenir des liens vers des sites tiers (LinkedIn, Calendly, etc.).
          MCM n'exerce aucun contrôle sur ces sites et décline toute responsabilité quant à leur contenu.
        </p>

        <h2>6. Crédits</h2>
        <p>
          Conception &amp; développement : Mohammed Toummini avec assistance Emergent Labs.
          Polices&nbsp;: Outfit &amp; Manrope (Google Fonts).
        </p>

        <h2>7. Droit applicable</h2>
        <p>
          Le présent site et ses mentions légales sont régis par le droit français.
          Tout litige relatif à leur interprétation ou exécution relèvera de la compétence
          exclusive des tribunaux français.
        </p>
      </div>
    </div>
  );
}

export function PolitiqueConfidentialite() {
  return (
    <div className="legal-page" data-testid="politique-confidentialite-page">
      <div className="mcm-container legal-container">
        <Link to="/" className="legal-back" data-testid="back-home-link-2">
          <ArrowLeft size={18} /> Retour à l'accueil
        </Link>
        <h1 className="legal-title">Politique de confidentialité</h1>
        <p className="legal-updated">Dernière mise à jour : 26 avril 2026</p>

        <h2>1. Responsable du traitement</h2>
        <p>
          Le responsable du traitement des données personnelles est&nbsp;:
        </p>
        <ul>
          <li>MCM – Mentis Consilium (SASU, SIRET 102 709 086 00015)</li>
          <li>Représentée par Mohammed Toummini, Président</li>
          <li>Email&nbsp;: <a href="mailto:mohammed.toummini@mentisconsilium.com">mohammed.toummini@mentisconsilium.com</a></li>
        </ul>

        <h2>2. Données collectées</h2>
        <p>Le site collecte uniquement les données que vous renseignez volontairement via le formulaire de contact&nbsp;:</p>
        <ul>
          <li>Nom complet</li>
          <li>Adresse email professionnelle</li>
          <li>Nom de l'entreprise (facultatif)</li>
          <li>Contenu du message</li>
        </ul>
        <p>
          Aucun cookie de mesure d'audience, aucune solution de tracking publicitaire et aucun outil d'analytics
          tiers ne sont déployés sur le site.
        </p>

        <h2>3. Finalité du traitement</h2>
        <p>Les données collectées sont utilisées exclusivement pour&nbsp;:</p>
        <ul>
          <li>Répondre à votre demande de contact ou de prise de rendez-vous,</li>
          <li>Établir et exécuter une éventuelle relation contractuelle.</li>
        </ul>
        <p>
          Aucune donnée n'est utilisée à des fins de prospection commerciale, ni revendue, ni cédée à des tiers.
        </p>

        <h2>4. Base légale</h2>
        <p>
          Le traitement repose sur votre <strong>consentement</strong> (envoi volontaire du formulaire)
          et, le cas échéant, sur l'<strong>exécution de mesures précontractuelles</strong> prises à votre demande
          (article 6.1.a et 6.1.b du RGPD).
        </p>

        <h2>5. Sous-traitants</h2>
        <p>Les outils suivants peuvent traiter vos données pour le compte de MCM&nbsp;:</p>
        <ul>
          <li><strong>Formspree</strong> (transmission du formulaire de contact) – serveurs aux USA, sous Data Privacy Framework.</li>
          <li><strong>Calendly</strong> (prise de rendez-vous) – serveurs aux USA, sous Data Privacy Framework.</li>
          <li><strong>Surge.sh / Netlify / Vercel</strong> (hébergement statique) – aucun traitement de données utilisateur côté serveur.</li>
        </ul>

        <h2>6. Durée de conservation</h2>
        <p>
          Les messages reçus via le formulaire de contact sont conservés <strong>3 ans maximum</strong>
          à compter du dernier échange, conformément aux recommandations de la CNIL.
          Les données liées à une relation contractuelle effective sont conservées 5 ans après la fin du contrat
          (durée légale de prescription).
        </p>

        <h2>7. Vos droits</h2>
        <p>Conformément au RGPD et à la loi Informatique et Libertés, vous disposez des droits suivants&nbsp;:</p>
        <ul>
          <li>Droit d'accès à vos données</li>
          <li>Droit de rectification</li>
          <li>Droit à l'effacement (« droit à l'oubli »)</li>
          <li>Droit à la limitation du traitement</li>
          <li>Droit à la portabilité</li>
          <li>Droit d'opposition</li>
          <li>Droit de retirer votre consentement à tout moment</li>
        </ul>
        <p>
          Pour exercer ces droits, écrivez à&nbsp;:
          <a href="mailto:mohammed.toummini@mentisconsilium.com"> mohammed.toummini@mentisconsilium.com</a>.
          Une réponse vous sera apportée sous un délai d'un mois maximum.
        </p>
        <p>
          Vous pouvez également déposer une réclamation auprès de la CNIL&nbsp;:
          <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer"> www.cnil.fr</a>.
        </p>

        <h2>8. Cookies</h2>
        <p>
          Le site n'utilise <strong>aucun cookie de mesure d'audience ni cookie publicitaire</strong>.
          Seuls des cookies techniques strictement nécessaires au fonctionnement peuvent être utilisés
          (préférences de session, sécurité). Aucun consentement préalable n'est donc requis.
        </p>

        <h2>9. Sécurité</h2>
        <p>
          Le site est servi exclusivement en HTTPS (chiffrement TLS). Les en-têtes de sécurité
          (X-Frame-Options, X-Content-Type-Options, Referrer-Policy, Permissions-Policy) sont
          configurés pour limiter les risques de clickjacking, MIME sniffing et fuite de référents.
        </p>

        <h2>10. Modifications</h2>
        <p>
          La présente politique peut être modifiée à tout moment pour rester conforme à la réglementation.
          La date de dernière mise à jour est indiquée en haut de page.
        </p>
      </div>
    </div>
  );
}
